import { VisualisationType } from '../store/types';

export function getVisibleDataPointsLimit(
  visualisationType: VisualisationType,
): number {
  switch (visualisationType) {
    case VisualisationType.BAR:
    case VisualisationType.TREND:
      return 15;
    case VisualisationType.PIE:
      return 15;
    default:
      return 10;
  }
}
